import { render, staticRenderFns } from "./alignCenter_on.vue?vue&type=template&id=1000eb46&"
import script from "./alignCenter_on.vue?vue&type=script&lang=ts&"
export * from "./alignCenter_on.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports